import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=dc932e3c&scoped=true"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateForm.vue?vue&type=style&index=0&id=dc932e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc932e3c",
  null
  
)

export default component.exports